import React from "react";

// Modules
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import PageHeader from "../../partials/pageHeader";
import ListHeader from "../../partials/listHeader";
import { Row } from "react-bootstrap";
import { useParams } from "react-router";
import { getEntityCategories } from "../../partials/posts/postHelpers";
import TermItem from "./termItem";

const listLabels = [
  { title: "Category name", width: { xs: 7 }, className: "" },
  {
    title: "Status",
    width: { xs: 2 },
    grow: true,
    colClass: "d-flex justify-content-center",
  },
  {
    title: "Operations",
    width: { xs: 3 },
    colClass: "justify-content-end d-flex",
  },
];

const TYPES = [
  {
    typeName: "news",
    typeLabel: "News categories",
    targetVid: "news_categories",
  },
  {
    typeName: "event",
    typeLabel: "Events categories",
    targetVid: "event_categories",
  },
  {
    typeName: "presentation",
    typeLabel: "Presentations categories",
    targetVid: "presentation_categories",
  },
  {
    typeName: "video",
    typeLabel: "Videos categories",
    targetVid: "video_categories",
  },
  {
    typeName: "gallery",
    typeLabel: "Galleries categories",
    targetVid: "gallery_categories",
  },
  {
    typeName: "podcast",
    typeLabel: "Podcasts categories",
    targetVid: "podcast_categories",
  },
  {
    typeName: "document",
    typeLabel: "Documents categories",
    targetVid: "document_categories",
  },
  {
    typeName: "training",
    typeLabel: "Training Courses categories",
    targetVid: "training_categories",
  },
  {
    typeName: "quiz",
    typeLabel: "Quizzes categories",
    targetVid: "quiz_categories",
  },
  {
    typeName: "link",
    typeLabel: "Links categories",
    targetVid: "link_categories",
  },
];

export default function TaxonomySingle(props) {
  const params = useParams();
  const id = params.id;
  const pageName = TYPES.find((item) => item.targetVid === id)?.typeLabel ?? "";
  const user = useSelector((state) => state).authReducer.user;
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    getEntityCategories({
      user,
      setCategories,
      targetVid: id,
    });
  }, []);

  const dataComponent = () => {
    console.log("categories", categories);

    const _categories = categories.filter((_item) => _item.value !== 0);
    return (
      <div className="terms-container">
        {_categories.map((item) => (
          <TermItem item={item} />
        ))}
      </div>
    );
  };

  return (
    <>
      <PageHeader
        pageName={pageName}
        filters={true}
        owner="client"
        pageNameColor="clientHeadingScreens"
        switchStatus={false}
      />
      <ListHeader
        items={listLabels}
        labelConfig={{
          owner: "client",
          variant: "subtitle1",
          color: "clientPrimary.main",
          weight: "medium",
          lh: "wide",
        }}
      />
      {dataComponent()}
    </>
  );
}
